import React, { useEffect } from "react";
// import * as tf from "@tensorflow/tfjs";
import { Routes, Route } from "react-router-dom";
import Home from "./Pages/Home";
import Inspection from "./Pages/Inspection";
import Upload from "./Pages/Upload";
import "./index.scss";
// import { setModelRedux } from "../src/Redux/Features/modelSlice";
import TermsCondition from "./Pages/Terms_Condition";
// import { useDispatch,useSelector } from 'react-redux';
import Thank from "./Pages/Thank";
import UploadError from "./Pages/UploadError";
import DamageSelection from "./Pages/DamageSelection";
import UploadCDF from "./Pages/Upload-CDF";

const App = () => {
  // console.log("Reached here");
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/terms&conditions" element={<TermsCondition />} />
      <Route path="/inspection" element={<Inspection />} />
      <Route path="/upload" element={<Upload />} />
      <Route path="/thank" element={<Thank />} />
      <Route path="/upload-error" element={<UploadError />} />
      <Route path="/damage-selection" element={<DamageSelection />} />
      <Route path="/upload-cdf" element={<UploadCDF />} />
    </Routes>
  );
};

export default App;
